var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 82,
    viewBox: "0 0 67 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.935 37.6999L43.1939 43.8139C43.7452 45.3054 45.2012 46.305 46.807 46.305H58.1281C59.7339 46.305 61.1899 45.3001 61.7412 43.8087L64.0001 37.6999H40.9297H40.935Z",
    fill: "#00A100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8894 36.1132H46.4052L51.7365 24.5092C52.0202 23.8904 52.9142 23.8904 53.1978 24.5092L58.5238 36.1132H61.0396L53.5083 19.7068C53.4013 19.4741 53.23 19.2943 52.9891 19.1673C52.3307 18.8447 46.3303 15.9992 37.9746 15.8564C38.1727 16.6233 38.1727 17.3585 37.9746 18.1254C43.5415 18.2259 47.9736 19.5957 50.1628 20.4261C50.5964 20.5901 50.7945 21.0767 50.6071 21.4945L43.8894 36.1132Z",
    fill: "#00A100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3364 65.9854H20.6646C20.2738 65.9854 19.958 66.2974 19.958 66.6782V69.0001H47.0429V66.6782C47.0429 66.2974 46.7271 65.9854 46.3364 65.9854Z",
    fill: "#00A100"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9566 58.66L22.8369 64.3986H44.1623L42.0426 58.66H24.9566Z",
    fill: "#00A100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7968 18.9082C36.7389 17.8028 36.6693 16.3166 36.0966 15.4598C34.935 13.5134 32.0713 13.5134 30.9044 15.4598C30.048 16.8719 30.5458 18.6807 31.8893 19.5005C33.099 20.2621 34.7905 20.0823 35.7915 18.9082H35.7968Z",
    fill: "#00A100"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2637 21.3834V57.0734H34.7366V21.3834C33.9177 21.6108 33.0826 21.6108 32.2637 21.3834Z",
    fill: "#00A100"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8368 20.4261C19.026 19.5957 23.4581 18.2259 29.025 18.1254C28.8216 17.3479 28.8269 16.618 29.025 15.8617C22.9175 15.9675 16.992 17.6547 13.9837 19.1832C13.7696 19.2996 13.593 19.4794 13.4913 19.7068L5.95996 36.1132H8.47576L13.8017 24.5092C14.0854 23.8904 14.9794 23.8904 15.263 24.5092L20.5944 36.1132H23.1102L16.3925 21.4945C16.1998 21.0766 16.4032 20.5901 16.8368 20.4261Z",
    fill: "#00A100"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87197 46.305H20.1984C21.8042 46.305 23.2548 45.3001 23.8062 43.8087L26.065 37.6999H3L5.25886 43.8139C5.8102 45.3054 7.26615 46.305 8.87197 46.305Z",
    fill: "#00A100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFive);
export default __webpack_public_path__ + "static/media/five.dafd399eb8b2452a68e0d04d02a8cad9.svg";
export { ForwardRef as ReactComponent };